<template>
  <div>
    <div v-if="isTestMode" class="test-watermark" aria-hidden="true"></div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    isTestMode() {
      return window.systemData && window.systemData.SYSTEM && window.systemData.SYSTEM.ifTest;
    }
  },
  created() {
    let _ = this;
    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      // Stash the event so it can be triggered later.
      if (_.$pwa.pwaRsp.prompt !== false) _.$pwa.pwaRsp.prompt = e;
    });
    window.addEventListener("appinstalled", () => {
      _.$pwa.pwaRsp.prompt = false;
    });
  },
  methods: {

  }
}
</script>

<style>
.test-watermark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='150'%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dominant-baseline='middle' font-family='Arial, sans-serif' font-size='48' font-weight='bold' fill='%23ff0000' opacity='0.03' transform='rotate(-30 100 75)'%3ETEST%3C/text%3E%3C/svg%3E");
  background-repeat: repeat;
  background-size: 200px 150px;
}
</style>
